import { render, staticRenderFns } from "./fieldsDisplay.vue?vue&type=template&id=005d0c5c&scoped=true&"
import script from "./fieldsDisplay.vue?vue&type=script&lang=ts&"
export * from "./fieldsDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./fieldsDisplay.vue?vue&type=style&index=0&id=005d0c5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d0c5c",
  null
  
)

export default component.exports